const routes = {
  // Company
  home: "/",
  contact: "/contact-us",
  about: "/about-us",
  cases: "/cases",
  blog: "/blog",

  // Services
  teamExtensionServices: "/services/team-extension-services",
  startupStudioServices: "/services/startup-studio-services",
  softwareEngineeringServices: "/services/software-engineering-services",

  // Industries
  logisticsIndustry: "/industries/logistics",
  eCommerceIndustry: "/industries/e-commerce",
  finTechIndustry: "/industries/fin-tech",

  // Expertise
  webDevelopment: "/services/web-development",
  mobileDevelopment: "/services/mobile-development",
  crossPlatformDevelopment: "/services/cross-platform-development",
  cloudDevOpsServices: "/services/cloud-dev-ops-services",
  troubleshootingBusinessScaling: "/services/troubleshooting-business-scaling",
  technologies: "/technologies",
  artificialIntelligenceConsulting:
    "/services/artificial-intelligence-consulting",

  // Case Studies
  casesFeodal: "/cases/feodal",
  casesBelovy: "/cases/belovy",
  casesAracor: "/cases/aracor",
  casesQyral: "/cases/qyral",

  // Admin
  adminPanel: "/admin",
};

export default routes;
